import React, { useState } from "react";
import { Card } from "@design-system/Card/Card";
import { CardSection } from "@design-system/Card/CardSection";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

export const CardPlayground = () => {
    const [hasSharpEdges, setHasSharpEdges] = useState(false);
    const [isStacked, setIsStacked] = useState(false);
    const [hasBorder, setHasBorder] = useState(true);
    const [hasLabel, setHasLabel] = useState(true);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Card style</h2>
                    <div className={styles.booleanGrid}>
                        <BooleanControl
                            label="Sharp edges"
                            checked={hasSharpEdges}
                            onChange={setHasSharpEdges}
                        />
                        <BooleanControl
                            label="Stacked"
                            checked={isStacked}
                            onChange={setIsStacked}
                        />
                        <BooleanControl
                            label="Border"
                            checked={hasBorder}
                            onChange={setHasBorder}
                        />
                        <BooleanControl
                            label="Label"
                            checked={hasLabel}
                            onChange={setHasLabel}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={hasSharpEdges ? "Sharp edges" : "Default"}
                width="wide"
                output={JSON.stringify(
                    {
                        componentProps: {
                            sharpEdges: hasSharpEdges,
                            stacked: isStacked,
                            noBorder: !hasBorder,
                            label: hasLabel ? "Bookkeeping" : null,
                        },
                        showcaseState: {},
                    },
                    null,
                    2,
                )}
            >
                <Card
                    sharpEdges={hasSharpEdges}
                    stacked={isStacked}
                    noBorder={!hasBorder}
                    label={hasLabel ? "Bookkeeping" : undefined}
                >
                    <CardSection>
                        <div className={styles.contentBlock}>
                            <h3>Monthly close</h3>
                            <p>
                                Review outstanding tasks before closing the
                                books.
                            </p>
                        </div>
                    </CardSection>
                    <CardSection>
                        <Card className={styles.nestedCard}>
                            <div className={styles.contentBlock}>
                                <h3>Nested card</h3>
                                <p>3 transactions still need attention.</p>
                            </div>
                        </Card>
                    </CardSection>
                </Card>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
